App.SmSortableComponent = Em.Component.extend
  classNames: [ 'sm-sortable' ]

  # настраиваемые параметры
  animation: 200
  scroll: true

  sortableElement: null

  componentByElement: (element) ->
    @get('childViews').find (c) ->
      Em.$(c.get('element')).is(element)

  disabledObserver: (->
    el = @get('sortableElement')
    el && el.option("disabled", @get('disabled'))
  ).observes('disabled')

  didInsertElement: ->
    @set 'sortableElement', new Sortable @$()[0],
      handle: '.sm-sortable-item'

      animation: @get('animation')
      scroll:    @get('scroll')
      disabled:  @get('disabled')

      onStart: (e) =>
        e.stopPropagation()
        childViews = {}
        @get('childViews').forEach (view) ->
          childViews[ view.$().index() ] = view
        @set('arrangedChildViews', childViews)
        @set('freezed', true)
        return false

      onUpdate: (evt) =>
        what  = @componentByElement(evt.item)
        av = @get('arrangedChildViews')
        return unless what and av
        where = av[ evt.newIndex ]

        layout = @get('childViews').map (view) =>
          [ view.$().index(), view.get('model') ]

        @sendAction('onItemReorder',
          what.get('model'),
          where.get('model'),
          layout,
          => @rerender())


App.SmSortableItemComponent = Em.Component.extend
  classNames: [ 'sm-sortable-item' ]
  attributeBindings: [ 'data-content' ]

  handleClick:(->
    secondArgument = @get('secondArgument')
    secondArgument = @ if secondArgument == '@'
    @sendAction 'action',
      @get('firstArgument'),
      secondArgument
  ).on('click')
